export default "__VITE_ASSET__ChHdkOPZ__"